import { Building2 } from 'lucide-react';
import TransporterMasterLedger from './transport/TransporterMasterLedger';
import RateCardEngine from './transport/RateCardEngine';

export default function TransportCompany() {
  return (
    <section aria-label="Transport company master" className="space-y-5">
      <div className="flex flex-wrap items-end justify-between gap-3 border-b border-logi-grid pb-4">
        <div>
          <div className="mb-2 flex items-center gap-2">
            <div className="flex h-7 w-7 items-center justify-center rounded-lg bg-logi-accent/100/10 ring-1 ring-blue-500/30">
              <Building2 className="h-4 w-4 text-blue-700" strokeWidth={1.75} />
            </div>
            <span className="text-xs font-semibold uppercase tracking-widest text-blue-700/80">
              OGTS LogiCore™ · Partner Network Module
            </span>
          </div>
          <h2 className="text-xl font-bold tracking-tight text-logi-text sm:text-2xl">
            Transport Company Master
          </h2>
          <p className="mt-1 text-sm text-logi-muted">
            Third-party logistics partners · Custom commercial pricing · UAE contract management
          </p>
        </div>
      </div>

      <TransporterMasterLedger />
      <RateCardEngine />
    </section>
  );
}
